import { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { supabase } from "@/integrations/supabase/client";
import { pickRealStore } from "@/lib/merchantStore";
import { trialDaysLeft, trialRemainingLabel } from "@/lib/trialDays";

/**
 * Trial summary pinned at the very top of the dashboard: days left + end date of the
 * free trial of the merchant's REAL store (store_settings.trial_end_date, server-written).
 * Hidden when there is no running trial.
 */
export const TrialSummaryBar = () => {
  const [endDate, setEndDate] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;
      const { data } = await supabase
        .from("store_settings")
        .select("id, created_at, trial_end_date")
        .eq("user_id", user.id);
      const picked = pickRealStore(data as any[], []);
      if (!cancelled) setEndDate((picked?.row as any)?.trial_end_date ?? null);
    })();
    return () => { cancelled = true; };
  }, []);

  const days = trialDaysLeft(endDate);
  if (!endDate || days <= 0) return null;

  return (
    <div
      role="status"
      className="mb-4 sm:mb-6 flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3 rounded-lg border border-primary/20 bg-primary/5 px-4 py-3"
    >
      <div className="flex items-center gap-2 font-semibold text-sm sm:text-base text-foreground">
        <Clock className="h-4 w-4 text-primary flex-shrink-0" />
        <span>{trialRemainingLabel(days)}</span>
      </div>
      <span className="text-sm text-muted-foreground sm:ml-auto">
        {`Fin de l'essai le ${format(new Date(endDate), "d MMMM yyyy", { locale: fr })}`}
      </span>
    </div>
  );
};
